import {Table as MantineTable} from '@mantine/core';

/**
 * Plain data table (with `Table.Thead`, `Table.Tr`, `Table.ScrollContainer`, …) — design-layer pass-through over Mantine `Table`.
 * @registry Pass-through Mantine Table for small embedded tables; admin record lists use useTable instead.
 */
export const Table = MantineTable;
